/**
 * Tables Routes
 */
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {config} from "../config";
// async components
import {
    AsyncDocumentTypeCreateComponent,
    AsyncDocumentTypeEditComponent,
    AsyncDocumentTypeListComponent
} from "../components/AsyncComponent/AsyncComponent";
import {documentTypeIdRegexp} from "../constants";

const DocumentTypes: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();

    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('documentTypes.name')}`}</title>
                <meta name="description" content="DocumentTypes"/>
            </Helmet>
            <Switch>
                <Route exact path={`${match?.url}`} component={AsyncDocumentTypeListComponent}/>
                <Route
                    exact
                    path={`${match?.url}/create`}
                    component={AsyncDocumentTypeCreateComponent}
                />
                <Route
                    exact
                    path={`${match?.url}/:id(${documentTypeIdRegexp})`}
                    component={AsyncDocumentTypeEditComponent}
                />
                <Redirect exact from={`${match?.url}/`} to={`${match?.url}`}/>
            </Switch>
        </div>
    );
};

export default DocumentTypes;
